import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight } = FiIcons;

const DashboardCard = ({ title, category, description, link, icon, featured = false }) => {
  return (
    <a 
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={`
        group block relative bg-[#F6F1E8] border border-[#D9CCBA]/60 rounded-2xl p-8 
        transition-all duration-500 ease-out hover:shadow-xl hover:shadow-[#D9CCBA]/20 
        hover:-translate-y-1 overflow-hidden
        ${featured ? 'md:col-span-2 lg:col-span-3 flex flex-col md:flex-row items-start md:items-center gap-8' : 'flex flex-col h-full'}
      `}
    >
      {/* Decorative hover effect background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FCFAF6]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>

      <div className={`flex-1 ${featured ? 'md:pr-8' : ''}`}>
        <div className="flex items-center justify-between mb-4">
          <span className="text-[10px] uppercase tracking-[0.2em] text-[#A67C52] font-semibold">
            {category}
          </span>
          <div className="w-8 h-8 rounded-full bg-[#FCFAF6] border border-[#D9CCBA]/40 flex items-center justify-center text-[#6E7451] group-hover:scale-110 transition-transform duration-500">
            <SafeIcon icon={icon} className="w-4 h-4" />
          </div>
        </div>
        
        <h3 className={`font-serif text-[#2F2B28] mb-3 leading-snug ${featured ? 'text-3xl' : 'text-2xl'}`}>
          {title}
        </h3>
        
        <p className="text-[#2F2B28]/70 leading-relaxed font-light mb-8">
          {description}
        </p>
      </div>

      <div className={`mt-auto ${featured ? 'mt-0 shrink-0' : ''}`}>
        <div className="inline-flex items-center space-x-2 text-sm uppercase tracking-widest text-[#6E7451] font-medium group-hover:text-[#2F2B28] transition-colors duration-300">
          <span>Open Page</span>
          <SafeIcon icon={FiArrowRight} className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" />
        </div>
      </div>
    </a>
  );
};

export default DashboardCard;